import { Component, inject } from '@angular/core';
import { AssetsIconsService } from '@stillmandigital/assets-icons';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [AssetsIconsService],
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class AppComponent {
  constructor() {
    const assetsIconsService = inject(AssetsIconsService);
    assetsIconsService.registerGlobalIcons();
  }
}
